import React from 'react';

import { DnsForwardingEditorContainer } from '../../../containers/DnsForwardingEditor.container';
import { TestID } from '../../../testID';

import type { DnsForwardingConfig } from 'Types/subscription.types';

interface Props {
  dnsConfig: DnsForwardingConfig;
  onSave: (config: DnsForwardingConfig) => Promise<void>;
  isSubmitting: boolean;
}

export const SettingsSubscriptionDnsView: React.FC<Props> = ({
  dnsConfig,
  onSave,
  isSubmitting,
}) => (
  <main className="scrollArea" data-testid={TestID.DnsForwardingSection}>
    <div className="row" style={{ margin: 0 }}>
      <div className="col gr-secondary">
        <h2 className="heading-section">Custom DNS Forwarding</h2>
        <p>
          Configure DNS forwarding rules for specific sub-domains. Queries to these domains will be
          forwarded to the specified DNS servers.
        </p>
      </div>
    </div>
    <br />
    <div className="row" style={{ marginLeft: 16 }}>
      <DnsForwardingEditorContainer
        dnsConfig={dnsConfig}
        onSave={onSave}
        isSubmitting={isSubmitting}
      />
    </div>
  </main>
);
